import { render } from "./ExtraOpmerkingen.vue?vue&type=template&id=040d4578"
import script from "./ExtraOpmerkingen.vue?vue&type=script&lang=js"
export * from "./ExtraOpmerkingen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__